import { render, staticRenderFns } from "./shiftManagementMonthDetail.vue?vue&type=template&id=0524bf84&scoped=true"
import script from "./shiftManagementMonthDetail.vue?vue&type=script&lang=js"
export * from "./shiftManagementMonthDetail.vue?vue&type=script&lang=js"
import style0 from "./shiftManagementMonthDetail.vue?vue&type=style&index=0&id=0524bf84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524bf84",
  null
  
)

export default component.exports